// Add product to cart with all add to cart buttons on the landing page

var atc_btn = document.querySelectorAll('.atc-submit');

window.onload = function() {
    atc_btn.forEach(function(btn) {
        btn.addEventListener('click', function() {
            document.querySelector('form.product-single__form button[type="submit"]').click();
        });
    });
}
